import { render, staticRenderFns } from "./Wap_YSY002_Step1.vue?vue&type=template&id=16f51876&scoped=true&"
import script from "./Wap_YSY002_Step1.vue?vue&type=script&lang=js&"
export * from "./Wap_YSY002_Step1.vue?vue&type=script&lang=js&"
import style0 from "./Wap_YSY002_Step1.vue?vue&type=style&index=0&id=16f51876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f51876",
  null
  
)

export default component.exports